import { colors, formatNumber } from '../styles/tokens'

// =======================================================================
// ModuleBreakdownRenderer — the ONE generic renderer for a module's
// optional renderBreakdown() output. Contains no module-specific
// knowledge; it only walks the generic { sections, summary, selectedBasis }
// shape any module MAY provide. If a module has none, callers fall back
// to a raw-JSON view instead of using this component.
// =======================================================================
export default function ModuleBreakdownRenderer({ breakdown }) {
  if (!breakdown) return null

  return (
    <div style={{ fontSize: 11, color: colors.textSecondary }}>
      {breakdown.sections?.map((section, si) => (
        <div key={si} style={{ border: `1px solid ${colors.border}`, borderRadius: 6, padding: 8, marginBottom: 6, background: '#FAFBFC' }}>
          <div style={{ fontWeight: 700, color: colors.textPrimary, marginBottom: 4 }}>{section.title}</div>
          {section.rows?.map((r, ri) => <Row key={ri} row={r} />)}
          {section.subsections?.map((sub, subi) => (
            <div key={subi} style={{ paddingTop: 4, marginTop: 4, borderTop: subi > 0 ? `1px dashed ${colors.border}` : 'none' }}>
              <div style={{ fontWeight: 600, color: colors.textPrimary, marginBottom: 2 }}>{sub.title}</div>
              {sub.rows?.map((r, ri) => <Row key={ri} row={r} />)}
            </div>
          ))}
          {section.footer && (
            <div style={{ marginTop: 6, paddingTop: 6, borderTop: `1px solid ${colors.border}`, fontWeight: 700, color: colors.textPrimary, display: 'flex', justifyContent: 'space-between' }}>
              <span>{section.footer.label}</span><span>{section.footer.value}</span>
            </div>
          )}
        </div>
      ))}

      {breakdown.summary && (
        <div style={{ padding: '8px 10px', background: '#F8FAFF', border: `1px solid ${colors.primary}`, borderRadius: 6, marginBottom: 6 }}>
          <div style={{ fontWeight: 700, color: colors.textPrimary, marginBottom: 4 }}>{breakdown.summary.title}</div>
          {breakdown.summary.rows?.map((r, ri) => <Row key={ri} row={r} />)}
        </div>
      )}

      {breakdown.selectedBasis && (
        <div style={{ padding: '8px 10px', background: colors.warningBg, borderRadius: 6, fontWeight: 700, color: colors.textPrimary, display: 'flex', justifyContent: 'space-between' }}>
          <span>{breakdown.selectedBasis.label}</span><span>{breakdown.selectedBasis.value}</span>
        </div>
      )}
    </div>
  )
}

function Row({ row }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1px 0', fontWeight: row.emphasis ? 700 : 400, color: row.emphasis ? colors.textPrimary : colors.textSecondary }}>
      <span>{row.label}</span><span>{row.value}</span>
    </div>
  )
}
